import { IntervalState as h } from "@ancon/wildcat-types";
import s from "moment";
import k from "../date/isDSTShiftPresentInRange.mjs";
import v from "./getPickerIntervalsForDay.mjs";
import y from "./getSettingsForOrderFormat.mjs";
import I from "./getServiceIntervalStart.mjs";
import { PickerTimeTimezoneTag as O } from "./types.mjs";
import D from "./generatePickerTimesForDay.mjs";
import b from "./getServiceIntervalEnd.mjs";
import x from "./getOutletNextReadyToOrderTime.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
import "../shared/constants.mjs";
import "../date/createLocalTimezoneMoment.mjs";
import "./getServiceIntervalsForOrderFormat.mjs";
import "../time/getTimeSpanParts.mjs";
import "../time/getNextTenthMinute.mjs";
import "./getServiceIntervalTimeSpanMoment.mjs";
import "./hoursAndMinutesToMinutes.mjs";
import "./isOutletAcceptingPreOrders.mjs";
import "./getOutletTagInformation.mjs";
import "./constants.mjs";
import "./getOutletCurrentActiveOperatingHour.mjs";
import "./getTimezoneAdjustedServiceInterval.mjs";
import "../date/convertToSpecificTimezone.mjs";
import "./searchNextOpeningMoment.mjs";
import "./getOutletNextServiceTimeOffset.mjs";
function R(t, m, o) {
  let f = t;
  return k(
    m,
    o
  ) && (f = t.filter((r) => {
    const n = s(r.timestamp).utc(!0), e = s(m).utc(!0);
    return n.isSameOrAfter(e);
  })), f;
}
function z(t) {
  const m = t[0], o = t[t.length - 1];
  if (k(
    m.timestamp,
    o.timestamp
  )) {
    const c = Math.max(
      s(m.timestamp).utcOffset(),
      s(o.timestamp).utcOffset()
    ), r = t.map((e) => e.timeLabel), n = r.filter(
      (e, i) => r.indexOf(e) !== i
    );
    return t.map((e) => {
      if (n.includes(e.timeLabel)) {
        const d = s(e.timestamp).utcOffset() === c ? O.Summer : O.Standard;
        return { ...e, timezoneTag: d };
      }
      return e;
    });
  }
  return t;
}
function it(t, m, o, f) {
  const { preparationTime: c = "00:00:00" } = y(m, t == null ? void 0 : t.orderFormatSettings) ?? {}, r = x(t, m);
  let n = r.clone();
  const e = s(o);
  if (e > r)
    n = r.clone().set({
      year: e.year(),
      month: e.month(),
      date: e.date()
    });
  else if (r.diff(e, "day") > 0)
    return [];
  let i = [];
  const d = v(
    n,
    t == null ? void 0 : t.serviceDateTimes,
    m
  );
  let S;
  return d.forEach((a) => {
    !S && a.type && (i = []);
    const p = I(
      n,
      a,
      c
    ), u = b(
      n,
      a,
      c
    );
    p < r && p.add(
      r.valueOf() - p.valueOf(),
      "millisecond"
    );
    const l = D(
      p,
      u,
      i,
      void 0,
      f
    );
    if (l.length > 0)
      switch (a.state) {
        case h.Closed: {
          const T = l[0], P = l[l.length - 1];
          i = i.filter(
            ({ timestamp: g }) => g < T.timestamp || g > P.timestamp
          );
          break;
        }
        case h.Opened:
        default: {
          const T = R(
            l,
            p,
            u
          );
          i = i.concat(T);
          break;
        }
      }
    S = a.type;
  }), i.length ? z(i) : i;
}
export {
  it as default
};
